import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import {
  CardType,
  CardTypeLabelEditText,
  CardTypeLabelPrintText,
} from '../../../common/spdCore/validation/schemas';
import { navigateToCardByType } from '../Cards/CardsLink';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

export const CardWithJudgmentLink: React.FC<{
  examId: string;
  active: boolean;
  cardType: CardType;
  cardId?: string;
}> = props => {
  const nav = useNavigation();
  const spd = useSpdCore();

  const handleOnClickEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigateToCardByType(nav, props.cardType, props.examId, true);
  };

  const handleClickPrint = () => {
    if (props?.cardId) {
      spd.pdfPrinter
        .loadAndPrintCard(props?.cardId)
        .catch(error =>
          console.log(`Wystąpił problem z wydrukiem karty. ${error}`),
        );
    }
  };

  return (
    <>
      {props?.cardId && (
        <>
          <OverlayTrigger
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {
                  CardTypeLabelEditText[
                    props.cardType as keyof typeof CardTypeLabelEditText
                  ]
                }
              </Tooltip>
            }
          >
            <Button onClick={handleOnClickEdit} variant="btn-info">
              <Icon.BoxArrowUpRight />
            </Button>
          </OverlayTrigger>
          {props?.cardId && props.active && (
            <OverlayTrigger
              overlay={
                <Tooltip style={{ position: 'fixed' }}>
                  {
                    CardTypeLabelPrintText[
                      props.cardType as keyof typeof CardTypeLabelPrintText
                    ]
                  }
                </Tooltip>
              }
            >
              <Button
                onClick={e => {
                  e.stopPropagation();
                  handleClickPrint();
                }}
                variant="btn-info"
              >
                <Icon.Printer />
              </Button>
            </OverlayTrigger>
          )}
        </>
      )}
    </>
  );
};
